<!-- List View -->
<div class="cd-section" id="regulations" style="background-color: white; padding-top: 100px" *ngIf="strView == 'list'">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h1>Catalogues Supported <span class="badge badge-pill badge-info align-top" style="font-size: .5em;">{{ regs.length }}</span></h1>
                    <h5>Our platform provides support for a rapidly growing number of standards, laws, and regulations that span many different industries.  Our compliance cloud allows our customers to ensure they are continuously compliant with these regulations by easily building compliance artifacts, conducting assessments, and pro-actively remediating any issues. The current list of supported regulations is shown in the table below: </h5>
                    <div class="input-group mt-4">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="strSearch" aria-label="search" name="search" aria-describedby="basic-addon1" (keyup.enter)="filter()">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table m-4">
                    <thead>
                        <tr>
                            <th style="font-weight: bold;">View</th>
                            <th style="font-weight: bold;">Regulation</th>
                            <th style="font-weight: bold;">Category</th>
                            <th style="font-weight: bold;">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of filtered">
                            <td>
                                <a [href]="r.url" [title]="r.name" target="_blank" class="btn btn-primary">Learn More</a>
                            </td>
                            <td>
                                {{ r.value }} <span *ngIf="r.paid == true" class="badge badge-pill badge-danger ml-2" title="NOTE: This is a proprietary catalogue that must be licensed by the customer in order to use.">PAID</span>
                            </td>
                            <td>
                                {{ r.category }}
                            </td>
                            <td>
                                <button *ngIf="r.paid == false" class="btn btn-success mr-3" download (click)="load(r)" title="Download the JSON file for loading as a RegScale catalogue"><i class="fas fa-download mr-1"></i>Download
                                </button>
                                <a *ngIf="r.paid != false" class="btn btn-danger mr-3" style="color: white;" title="Contact a Sales Representative to provide proof of your paid license in order to download."><i class="fas fa-phone mr-1"></i>Contact Us
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Download View -->
<div class="cd-section" id="regulations" style="background-color: white; padding-top: 100px" *ngIf="strView == 'download'">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <a style="color: gray;" (click)="back()"><i class="fas fa-arrow-left ml-2"></i> Back</a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h1><i class="fas fa-download"></i> Download</h1>
                    <h5>Below are multiple options for conveniently downloading the selected catalog: </h5>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card" style="width: 100%;">
                    <div class="card-header">
                      <h3 style="font-weight: bold !important;">{{ selected.value }}</h3>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" style="margin-bottom: 35px; margin-top: 35px;"><span style="font-weight: bold;">Curl:</span> <span style="color: #1a70ad">{{selected.curl }}</span> <i class="far fa-copy ml-2" (click)="copy(selected.curl)"
                            title="Click to copy to your clipboard."></i></li>
                      <li class="list-group-item" style="margin-bottom: 35px;"><span style="font-weight: bold;">PowerShell:</span> <span style="color: #1a70ad">{{selected.powershell }}</span> <i class="far fa-copy ml-2" (click)="copy(selected.powershell)"
                        title="Click to copy to your clipboard."></i></li>
                    </ul>
                  </div>
            </div>
        </div>
    </div>
</div>

